<template>
  <v-row>
    <v-col>
      <ReportHeading
        label="Бонуси Менеджерів"
        :loading="loading"
        @update-report="updateReport"
      >
        <template v-slot:action>
          <DownloadFile
            location="xlsx"
            :params="reportData"
            filename="Бонуси Менеджерів"
            extension="xlsx"
            tooltip="Завантажити у форматі Excel"
          />
        </template>
        <template v-slot:filters>
          <v-col
            md="4"
            sm="12"
            class="pa-0 pb-3"
          >
            <DatePicker
              v-model="month"
              class="ma-1"
              label="Місяць"
              type="month"
              default-value
              :filled="false"
              @input="updateReport"
            />
          </v-col>
        </template>
      </ReportHeading>
      <v-card class="mt-2">
        <SimpleTable
          :headers="headers"
          :loading="loading"
          :items-per-page="filteredItems.length"
          :items="filteredItems"
        />
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import DatePicker from "@/components/story/DatePicker.vue";
import DownloadFile from "@/components/DowloadFile.vue";
import SimpleTable from "@/components/story/SimpleTable";
import { getManagersBonuses } from "@/backend/reportsApi.js";
import ReportHeading from "../../../components/ReportHeading.vue";

export default {
  components: {
    DatePicker,
    DownloadFile,
    SimpleTable,
    ReportHeading,
  },
  data: () => ({
    loading: false,
    items: [],
    headers: [
      { text: "Менеджер", value: "manager", type: "text" },
      { text: "План", value: "salesPlan", type: "text" },
      { text: "Бонус", value: "bonus", type: "text" },
    ],
    month: "",
  }),
  computed: {
    filteredItems() {
      return this.items;
    },
    reportData() {
      const rows = [];
      this.items.forEach((item) => {
        item.details.forEach((detail) => {
          detail.products.forEach((product) =>
            rows.push([
              item.manager.title,
              item.salesPlan.toFixed(2),
              item.bonus.toFixed(2),
              detail.payment.title,
              detail.invoice.title,
              detail.client.title,
              detail.bonusCoefficient.toFixed(2),
              product.title,
              product.purchaseCost.toFixed(2),
              product.amount.toFixed(2),
              product.percent.toFixed(2),
              product.bonusBase.toFixed(2),
            ])
          );
        });
      });

      return {
        columns: [
          "Менеджер",
          "План",
          "Бонус итого",
          "Оплата",
          "Счет",
          "Клиент",
          "Коэф Счет/Оплата",
          "Продукт",
          "Себестоимость",
          "Сумма",
          "Категория %",
          "Бонус",
        ],
        rows,
      };
    },
  },
  created() {
    this.updateReport();
  },
  methods: {
    async updateReport() {
      this.loading = true;

      try {
        this.items = await getManagersBonuses(this.month);
      } catch {
        this.$notifyWarning("В даних звіту помилки. Подивіться в Система/Стан БД");
      }

      this.loading = false;
    },
  },
};
</script>
